import React from 'react';
import PropTypes from 'prop-types';

import PlayerButton from '../PlayerButton';
import Favourite from 'components/svg/Favourite';

const PlayerFavorites = ({ isFavorite, toggleFavorite, isVisible }) => {
  if (!isVisible) {
    return null;
  }
  const renderIcon = () => {
    return <Favourite isActive={isFavorite} />;
  };

  return (
    <PlayerButton
      data-testid="player-bottom-favorites-btn"
      active={isFavorite}
      onPress={toggleFavorite}
      title="Favorieten"
      renderIcon={renderIcon}
      hideOnSmall
    />
  );
};

PlayerFavorites.propTypes = {
  toggleFavorite: PropTypes.func.isRequired,
  isFavorite: PropTypes.bool,
  isVisible: PropTypes.bool,
};

PlayerFavorites.defaultProps = {
  isFavorite: false,
  isVisible: false,
};

export default PlayerFavorites;
